// Typelizer digest 57b555b81c1de809c684cee31ad2e630
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/teachers/:teacher_id/relief/listings/:id/close */
  close: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/listings/:id/close', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/relief/listings */
  index: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/listings', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/relief/listings */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/listings', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/relief/listings/new */
  new: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/listings/new', params, options),
    method: 'get',
  }),
}
